// Tiny environment-aware logger. Debug output is stripped from production
// builds (CRA inlines NODE_ENV, so the dead branch is removed by the minifier);
// warnings and errors always surface so real failures are never silent.
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
